const languages = {
  languages: 'Languages',
  addLanguages: 'Add Languages',
  editLanguages: 'Edit Languages',
};
export default languages;
